
import React, { useState, useEffect } from 'react';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, isResultOk } from './../../components/special/apiCall';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextRegno from './../../components/text/TextRegno';
import TextPhonenumber from './../../components/text/TextPhonenumber';
import ReactTooltip from 'react-tooltip';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const Courts = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/court/summary/');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  return (    
    <div>      
      <ListHeader title={t("Héraðsdómar")}/>      
      <ReactTooltip/>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['20%', '35%', '20%', '25%']}
          headers = {[
            t("Kennitala"),
            t("Embætti"),
            t("Símanúmer"),
            t("Heimilisfang")
          ]}
          columns = {[
            (item) => (<TextRegno value={item.regno}/>),
            (item) => (
              <a href={item.website}
                  target="_blank"
                  rel="noopener noreferrer"                  
                  data-tip="Opna vefsíðu dómstóls í nýjum glugga"
              >{item.name} </a>),
            (item) => (<TextPhonenumber value={ item.phoneNumber }/>),
            (item) => (<>{ item.address }</>)              
          ]}

      />
  </div>
  );
};







